import { all, takeLatest } from 'redux-saga/effects'
import store from '../../store'
import { actions } from './CustomLabelPrintsPaginate.slice'
import { paginate } from './CustomLabelPrintsPaginate.thunk'

function paginateCustomLabelPrints () {
  store.dispatch(paginate() as any)
}

export default function * effects () {
  yield all([
    takeLatest(actions.replaceLimit, paginateCustomLabelPrints),
    takeLatest(actions.replacePage, paginateCustomLabelPrints),
    takeLatest(actions.replaceFilters, paginateCustomLabelPrints)
  ])
}
